import { render } from "./SelfServiceAbsences.vue?vue&type=template&id=56b36ac6"
import script from "./SelfServiceAbsences.vue?vue&type=script&lang=js"
export * from "./SelfServiceAbsences.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__